export const CATEGORIES_LIST = [
  {
    label: 'Select Category',
    value: '',
  },
  {
    label: 'CAT5',
    value: 'CAT5',
  },
  {
    label: 'CAT4',
    value: 'CAT4',
  },
  {
    label: 'CAT3',
    value: 'CAT3',
  },
  {
    label: 'CAT2',
    value: 'CAT2',
  },
  {
    label: 'CAT1',
    value: 'CAT1',
  },
];
